import React from "react";
import Button from "../../../form/Button";
import BannerImage from "../../../../assets/image/image-banner-hero.webp";
import Image from "../../../elements/Image";
import useFetch from "../../../../hooks/useFetch";
import { useBanner } from "../../../../providers/BannerProviders";
import { classNames } from "../../../../helpers/classNames";

const HomeBanner = () => {
  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.bannerType === "home");

  return (
    <>
      <section className="relative flex w-full h-[calc(70vh-3rem)] xls:h-[calc(100vh-3rem)] overflow-hidden items-center pt-12">
        <div className="absolute w-full h-full left-0 top-0 flex after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-chestnut-rose after:opacity-30">
          {homeBanner?.image?.url && (
            <Image
              src={homeBanner?.image?.url}
              alt="hero-banner"
              effect={"fade"}
              classes={"object-cover"}
            />
          )}
        </div>
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="relative w-full max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl xls:text-[66px] font-bold text-white text-center !leading-normal">
              {homeBanner?.title}
            </h1>
            <div className="relative flex items-center justify-center gap-2 md:gap-6 mx-auto mt-20">
              {(homeBanner?.button || [])?.map((btn, i) => (
                <Button
                  key={i}
                  buttonClasses={classNames(
                    "!h-12 xls:!h-14 !rounded-full !px-4 md:!px-6 !border !border-white md:!min-w-[180px]",
                    i === 1 ? "!bg-gable-green hover:!bg-blue-zodiac" : ""
                  )}
                  buttonType={"button"}
                  buttonLabel={btn?.buttonText || ""}
                  {...(btn?.buttonLink
                    ? { buttonHasLink: true, buttonLink: btn?.buttonLink }
                    : { buttonHasLink: false })}
                  {...(btn?.buttonLink &&
                    (btn.buttonLink.includes("http://") ||
                      btn.buttonLink.includes("https://")) && {
                      target: "_blank",
                    })}
                  buttonLabelClasses={"text-base xls:!text-lg"}
                />
              ))}

              {/* <Button
                buttonClasses={"!h-12 xls:!h-14 !rounded-full !px-4 md:!px-6 !border !border-white md:!min-w-[180px] !bg-gable-green hover:!bg-blue-zodiac"}
                buttonHasLink={true}
                buttonLink={"/"}
                buttonLabel={"Get Started"}
                buttonLabelClasses={"text-base xls:!text-lg"}
              /> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;
